import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box } from '@chakra-ui/react';
import { UniqueIdentifier } from '@dnd-kit/core';

type SortableItemProps = {
  id: UniqueIdentifier;
  item: React.ReactNode | string;
};

const SortableItem = ({ id, item }: SortableItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  return (
    <Box
      ref={setNodeRef}
      transition={transition}
      {...attributes}
      {...listeners}
      m={2.5}
      transform={CSS.Translate.toString(transform)}
    >
      {item}
    </Box>
  );
};

export default SortableItem;
